import type { LegalDocumentWords } from "./legal-words.ts";

// The Legal Notice (Impressum) in Spanish, a translation of legal-notice-en.ts (ADR-024, D701). The
// English text controls; change the Spanish text in the same commit as the English one.

export const NOTICE_ES: LegalDocumentWords = {
  title: "Aviso legal",
  summary:
    "Información sobre el proveedor de {product}, conforme al § 5 de la ley alemana de servicios digitales (DDG).",
  seoDescription: "Los datos legales de {company}, la empresa detrás de {product}, según la ley alemana.",
  sections: [
    {
      id: "provider",
      heading: "Proveedor",
      body: ["{company}", "{address}", "{product} es un producto de {company}."],
    },
    {
      id: "represented",
      heading: "Representado por",
      body: ["{director}, Director general"],
    },
    {
      id: "register",
      heading: "Registro mercantil",
      body: ["Inscrita en el {court} con el número {register}."],
    },
    {
      id: "contact",
      heading: "Contacto",
      body: ["Correo electrónico: {contact}"],
    },
    {
      id: "content",
      heading: "Responsable del contenido",
      body: ["Conforme al § 18(2) MStV: {director}, {address}."],
    },
    {
      id: "disputes",
      heading: "Resolución de disputas de consumo",
      body: [
        "No estamos obligados ni dispuestos a participar en procedimientos de resolución de disputas ante una junta de arbitraje de consumo.",
      ],
    },
  ],
};
